import { initCustomElements } from '@wix/thunderbolt-custom-elements'
import { isExperimentOpen } from '@wix/thunderbolt-experiments'

const { experiments, media, requestUrl, site } = window.viewerModel
const isCustomImageDomainEnabled = isExperimentOpen(experiments, 'specs.thunderbolt.customImageDomain')

initCustomElements({
	experiments,
	media,
	requestUrl,
	externalBaseUrl: site?.externalBaseUrl,
	userDomainMediaPrefixes: isCustomImageDomainEnabled ? media?.userDomainMediaPrefixes : undefined,
})
